import '@expo/metro-runtime';
import { StoreProvider } from 'easy-peasy';
import { registerRootComponent } from 'expo';
import App from './App';
import { NotificationProvider } from '@/components/ui/therapist/Notification/NotificationProvider';
import store from './stores/store';

function EntryComponent() {
  return (
    <StoreProvider store={store}>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </StoreProvider>
  );
}

export default registerRootComponent(EntryComponent);
